<template>
    <div>
        <header>
            <div class="header-row">
                <nav class="navbar navbar-expand">
                    <!-- Links -->
                    <ul class="navbar-nav align-items-center">
                        <li @click.stop.prevent="backHandler" class="nav-item ex-btn-left" v-if="enableBackButton">
                            <a class="nav-link" href="#">
                                <i class="icon-back-red"></i>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link ex-nav-logo" href="#">
                                <img src="@/assets/img/logo_jtb.png" alt="Logo" class="nav-link-logo" />
                            </a>
                        </li>
                        <li class="nav-item pl-2 user-info" v-if="user">
                            <div class="user-info">
                                <img src="@/assets/sprite/icon-user@2x.png" height="14"/>
                                <span class="user-name">{{user.full_name}}</span>
                            </div>
                            <div class="user-info">{{user.company_name}}</div>
                            <div class="user-info">{{user.branch}}</div>
                        </li>
                        <li class="nav-item ex-btn-right">
                            <a class="nav-link" v-if="enableButton" @click.stop.prevent="actionHandler">
                                <div v-html="buttonName"></div>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
    </div>
</template>

<script>
import Utils from '@/helpers/utils';
import StorageService from "@/services/common/storage.service";
require("@/assets/css/header_sp.css");
export default {
    name: "SpHeader",
    props: {
        backHandler: {
            type: Function,
        },
        actionHandler: {
            type: Function,
        },
        enableButton: {
            type: Boolean,
            default: false,
        },
        buttonName: {
            type: String,
            default: "",
        },
    },
    data () {
        let user = JSON.parse(StorageService.getUser());
        if(user && !Utils.isEmptyArr(user.groups)){
            user.branch = `(${user.groups[0].branch_code})${user.groups[0].branch_name}`;
            user.company_name = user.groups[0].company_name;
        }
        return {
            enableBackButton: true,
            user: user,
        };
    },
    watch: {
        $route: function () {
            if (this.$route.path === "/tour/input") {
                this.enableBackButton = false;
            } else {
                this.enableBackButton = true;
            }
        },
    },
    beforeMount () {
        if (this.$route.path === "/tour/input") {
            this.enableBackButton = false;
        } else {
            this.enableBackButton = true;
        }
    },
};
</script>


// WEBPACK FOOTER //
// src/views/layout/sp/Header.vue